<template>
  <NuxtLayout v-if="isKeepalivePage">
    <KeepAlive>
      <NuxtPage :key="$route.path" />
    </KeepAlive>
  </NuxtLayout>
  <NuxtLayout v-else :key="$route.path">
    <NuxtPage />
  </NuxtLayout>
</template>

<script lang="ts" setup>
import { UN_KEEPALIVE_ROUTES } from "~/utils/route";
const route = useRoute();
const isKeepalivePage = computed(
  () => !UN_KEEPALIVE_ROUTES.some((path) => !!~route.path.indexOf(path))
);
onMounted(() => {
  useLocale();
  useTokenReflesh();
});
</script>
